import { render, staticRenderFns } from "./SalesUserList.vue?vue&type=template&id=2ba38634&scoped=true"
import script from "./SalesUserList.vue?vue&type=script&lang=js"
export * from "./SalesUserList.vue?vue&type=script&lang=js"
import style0 from "./SalesUserList.vue?vue&type=style&index=0&id=2ba38634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba38634",
  null
  
)

export default component.exports